/**
 * Clients whose kept-alive detail shows outdated data because a change made on another client's detail
 * reached them: a group save on a MASTER-Mandant changes the Gruppe card of every member it adds or
 * removes (#2610074). The detail is kept alive per client URL and does not load again on return
 * (`ClientAdministrationDetail.vue`), so such a member showed its old card, still offering to become a
 * MASTER-Mandant, until Aktualisieren (Taimoor, 2026-10-20).
 *
 * Plain module state, not reactive: written after a save and read once by the detail's `activated`
 * hook. Vue 2's keep-alive cannot drop one kept page, so the page reloads itself instead.
 */
const stale = new Set<string>();

/** Marks a client's detail as outdated, so it loads again the next time it is shown. */
export function markClientDetailStale(clientId: string): void {
  stale.add(clientId);
}

/**
 * Whether the client's detail was marked outdated, and the mark removed: the caller loads it now, and a
 * fresh load supersedes the mark either way.
 */
export function takeClientDetailStale(clientId: string): boolean {
  return stale.delete(clientId);
}
